const WelcomeContent: any = () => (
	<div style={{ fontSize: '150%', textAlign: 'center', marginTop: '5%' }}>
		<h1>Welcome Super Admin!</h1>
		<p>Please choose your screen from the menu above.</p>
	</div>
)
export default WelcomeContent
